(function () {
    'use strict';

    angular
        .module('app')
        .factory('ChilliUserProfileService', ChilliUserProfileService);

    ChilliUserProfileService.$inject = ['$window', '$http', '$q', '$rootScope', 'DialogService', 'UrlService', 'ChilliTenancyService'];

    /*
     * NB: ChilliUserProfileService.userProfile will be null until after the user profile has been fully loaded, therefore it should not be used when
     * the calling operation is synchronous. For these situations ChilliUserProfileService.getUserProfile should be used.
     *
     */

    function ChilliUserProfileService($window, $http, $q, $rootScope, DialogService, UrlService, ChilliTenancyService) {
        var service = {
            getUserProfile: getUserProfile,
            userProfile: null,
            get userIsAdministrator() { return profileHasActivityPermission('administrator'); },
            verifyUserIsAdministrator: verifyUserIsAdministrator
        };

        var userProfileCache = {};
        var lastLoggedInUserId = null;
        
        $rootScope.$watch(
            function () { return ChilliTenancyService.selectedTenancyId; },
            function (newTenancyId) {
                service.userProfile = null;
                if (newTenancyId) {
                    updateUserProfile();
                }
            });

        $rootScope.$on('chilliAuth:logout', function () {
            if (!_.isNil(service.userProfile)) {
                lastLoggedInUserId = service.userProfile.Id;
            } else {
                lastLoggedInUserId = null;
            }

            service.userProfile = null;
            userProfileCache = {};
        });

        return service;


        /**
         * Update the cached user profile.
         * Presents an error dialog if the profile could not be loaded.
         */
        function updateUserProfile() {
            getUserProfile().catch(function (response) {
                DialogService.error('Error loading User profile', response);
            });
        }

        /**
         * Returns a promise for the user profile for the logged in user in the currently selected tenancy.
         * Uses an internal cache to avoid making more than one HTTP call per tenancy.
         *
         * @param {bool} skipCache - True if the cache should be skipped and user profile re-loaded from server.
         */
        function getUserProfile(skipCache) {
            if (_.isNil(skipCache)) {
                skipCache = false;
            }

            var tenancyId = ChilliTenancyService.selectedTenancyId;

            if (!skipCache && userProfileCache[tenancyId]) {
                service.userProfile = userProfileCache[tenancyId];
                return $q.resolve(userProfileCache[tenancyId]);
            } else {
                if (_.isNil(getUserProfile.promise)) {
                    getUserProfile.promise = [];
                }

                if (_.isNil(getUserProfile.promise[tenancyId])) {
                    getUserProfile.promise[tenancyId] = $http.get(UrlService.getWebAPIUrl() + '/userprofile')
                        .then(getUserProfileOk, getUserProfileError);
                }

                return getUserProfile.promise[tenancyId];
            }

            function getUserProfileOk(response) {
                delete getUserProfile.promise[tenancyId];
                if (!_.isNil(lastLoggedInUserId)) {
                    if (lastLoggedInUserId !== response.data.Id) {
                        // Logged in as a different user, *hard* reload to clear any and all application state
                        $window.location.reload();
                    }
                }

                userProfileCache[tenancyId] = response.data;

                if (tenancyId === ChilliTenancyService.selectedTenancyId) {
                    service.userProfile = response.data;
                }
                
                return response.data;
            }

            function getUserProfileError(response) {
                delete getUserProfile.promise[tenancyId];
                return $q.reject(response);
            }
        }

        /**
         * Returns true if there is a user profile loaded, and it has the specified activity permission.
         */
        function profileHasActivityPermission(activityName) {
            if (!service.userProfile) {
                return false;
            }
            
            return Array.isArray(service.userProfile.ActivityPermissions) &&
                service.userProfile.ActivityPermissions.indexOf(activityName) != -1;
        }

        /**
         * Verify that the user is an administrator.
         *
         * @param {object} settings - A settings object with these optional properties:
         *   {function} onUserIsAdmin - Callback triggered if the user is an administrator.
         *   {function} onUserIsNotAdmin - Callback triggered if the user is not an administrator.
         *   {function} onError - Callback triggered if there is an error loading the user profile,
         *     first argument will be a HttpResponse object if the error was due to HTTP issues.
         *   {function} onFinally - Callback triggered after all other callbacks, regardless of 
         *     whether user is admin, or there was an error.
         *
         * @returns {promise} A promise that resolves once user-is-admin status is determined, 
         *   or an error occurred.
         */
        function verifyUserIsAdministrator(settings) {
            if (_.isNil(settings)) {
                settings = {};
            }

            var promise = service.getUserProfile().then(getProfileOk, getProfileError);

            if (angular.isFunction(settings.onFinally)) {
                promise.finally(settings.onFinally);
            }

            return promise;

            function getProfileOk() {
                if (service.userIsAdministrator) {
                    if (angular.isFunction(settings.onUserIsAdmin)) {
                        return settings.onUserIsAdmin();
                    } else {
                        return true;
                    }
                } else {
                    if (angular.isFunction(settings.onUserIsNotAdmin)) {
                        return settings.onUserIsNotAdmin();
                    } else {
                        return false;
                    }
                }
            }

            function getProfileError(response) {
                if (angular.isFunction(settings.onError)) {
                    return settings.onError(response);
                } else {
                    return $q.reject(response);
                }
            }
        }
    }
})();
